import type {
  BaseAppSettings,
  ReferencedAppSettings
} from "@certa/studio-core";
import type { MegaJSONLookupData } from "./processLookup.types";
import Worker from "./processLookup.worker?worker";
import { devLogger } from "@certa/common/utils/devLogger";

type LookupReturnType = {
  megaJSONLookupData: MegaJSONLookupData;
  referencedAppSettings: ReferencedAppSettings;
  newBaseAppSettings: BaseAppSettings;
  shouldUpdateReferenceSettings: boolean;
};

export type WorkerInstance = Worker & {
  __pendingMessageCount?: number;
  __isProcessing?: boolean;
};

export const instantiateMegaJSONLookupWorker = (
  onSuccess: (props: LookupReturnType) => void
) => {
  const worker: WorkerInstance = new Worker();

  // Track processing state for queue management
  worker.__pendingMessageCount = 0;
  worker.__isProcessing = false;

  worker.onmessage = (event: MessageEvent<LookupReturnType>) => {
    worker.__isProcessing = false;
    worker.__pendingMessageCount = Math.max(
      0,
      (worker.__pendingMessageCount || 0) - 1
    );

    const result = event.data;
    onSuccess(result);
  };

  worker.onerror = (error: ErrorEvent) => {
    worker.__isProcessing = false;
    worker.__pendingMessageCount = Math.max(
      0,
      (worker.__pendingMessageCount || 0) - 1
    );
    devLogger.error("Error in lookup worker", error);
  };

  return worker;
};
